import React, {useState} from 'react'

import cn from '../../libs/class-names'

import chevronLeftIcon from '../../assets/icons/chevron-left.svg'
import chevronRightIcon from '../../assets/icons/chevron-right.svg'
import closeIcon from '../../assets/icons/close.svg'

import Icon from '../icon'
import Image from '../image'

export interface Props {
  classNames?: string[]
  imageUrls: string[]
  onClose: () => void
  defaultImageIndex?: number
}

const ImageLightbox = ({classNames, imageUrls, onClose, defaultImageIndex = 0}: Props) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(
    defaultImageIndex > 0 && defaultImageIndex <= imageUrls.length ? defaultImageIndex : 0
  )

  const handleOnPrevious = () => {
    if (currentImageIndex === 0) {
      setCurrentImageIndex(imageUrls.length - 1)
    } else {
      setCurrentImageIndex(currentImageIndex - 1)
    }
  }

  const handleOnNext = () => {
    if (currentImageIndex === imageUrls.length - 1) {
      setCurrentImageIndex(0)
    } else {
      setCurrentImageIndex(currentImageIndex + 1)
    }
  }

  return (
    <div className={cn('ImageLightbox', {}, classNames)}>
      <div className="ImageLightbox__header">
        <button className="ImageLightbox__close" type="button" onClick={onClose}>
          <Icon source={closeIcon} />
        </button>
      </div>
      {imageUrls.length > 0 ? (
        <>
          <div
            className="ImageLightbox__content"
            onClick={(event: React.MouseEvent<HTMLElement>) => {
              event.preventDefault()
              if (event.target && !(event.target as HTMLElement).classList.contains('Image')) {
                onClose()
              }
            }}
          >
            <div className="ImageLightbox__image">
              <Image src={imageUrls[currentImageIndex]} fit="contain" />
            </div>
          </div>
          {imageUrls.length > 1 && (
            <div className="ImageLightbox__footer">
              <button className="ImageLightbox__previous" type="button" onClick={handleOnPrevious}>
                <Icon source={chevronLeftIcon} />
              </button>
              <div className="ImageLightbox__dots">
                {imageUrls.map((_, index) => (
                  <span
                    key={index}
                    className={`ImageLightbox__dot${
                      index === currentImageIndex ? ' ImageLightbox__dot--active' : ''
                    }`}
                  />
                ))}
              </div>
              <button className="ImageLightbox__next" type="button" onClick={handleOnNext}>
                <Icon source={chevronRightIcon} />
              </button>
            </div>
          )}
        </>
      ) : (
        <div className="ImageLightbox__content">no images</div>
      )}
    </div>
  )
}

export default ImageLightbox
